<template>
  <div>
    <h4 class="text--subtitle-1">{{$t('message.props.options')}}</h4>
    <v-container>
      <v-form ref="optionsList">
        <v-row v-for="(item, index) in list" :key="index" class="ma-0">
          <v-col cols="4" :md="type === 18 ? 5 : 3"  class="pa-0 px-1">
            <v-text-field outlined v-model="item.label" dense label="Label" @focus="focusingLabelIndex = index" @blur="focusingLabelIndex = -1" :rules="$_optionsLabeleUniqueValidation"></v-text-field>
          </v-col>
          <v-col cols="4" :md="type === 18 ? 5 : 3" class="pa-0 px-1">
            <v-text-field @focus="focusingValueIndex = index" @blur="focusingValueIndex = -1" v-model="item.value"
              :rules="$_optionsValueUniqueValidation" outlined dense label="Value" required></v-text-field>
          </v-col>
          <v-col cols="4" :md="type === 18 ? 2 : 3" v-if="list.length > 1">
            <v-row>
              <v-btn fab dark x-small color="error" @click="removeOption(index)" text>
                <v-icon dark size="21">mdi-minus-circle</v-icon>
              </v-btn>
              <v-checkbox dense class="mx-1 pt-1 mt-0" v-model="item.isactive" hide-details></v-checkbox>
            </v-row>
          </v-col>
        </v-row>
        <v-btn v-if="type === 18 && (ismultiselect || fieldType !== 'checkbox' )" class="mt-0" @click="addNewOption" fab dark x-small color="primary">
          <v-icon dark>mdi-plus</v-icon>
        </v-btn>
        <v-btn v-else-if="type !== 18" class="mt-0" @click="addNewOption" fab dark x-small color="primary">
          <v-icon dark>mdi-plus</v-icon>
        </v-btn>
      </v-form>
    </v-container>
  </div>
</template>
<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => []
    },
    ismultiselect: {
      type: Boolean,
      default: false
    },
    fieldType: {
      type: String,
      default: () => ''
    },
    type: {
      type: Number
    }
  },
  data () {
    return {
      focusingValueIndex: -1,
      focusingLabelIndex: -1
    }
  },
  computed: {
    $_optionsValueUniqueValidation () {
      return [val => {
        var result
        if (!val) result = 'Required'
        else {
          let values = []
          if (this.focusingValueIndex > -1) values = this.list.filter((x, index) => index !== this.focusingValueIndex).map(x => x.value)
          result = values.includes(val) ? 'Value should not be same as previous ones' : true
        }
        return result
      }]
    },
    $_optionsLabeleUniqueValidation () {
      return [val => {
        var result
        if (!val) result = 'Required'
        else {
          let labels = []
          if (this.focusingLabelIndex > -1) labels = this.list.filter((x, index) => index !== this.focusingLabelIndex).map(x => x.label)
          result = labels.includes(val) ? 'Label should not be same as previous ones' : true
        }
        return result
      }]
    }
  },
  methods: {
    addNewOption () {
      this.list.push({ isactive: true })
    },
    removeOption (index) {
      this.list.splice(index, 1)
    }
  }
}
</script>
